"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HTMLContent = _interopRequireDefault(require("../common/HTMLContent"));

var _withSSIContent = require("../common/withSSIContent");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var SSIHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(SSIHeader, _Component);

  var _super = _createSuper(SSIHeader);

  function SSIHeader() {
    (0, _classCallCheck2.default)(this, SSIHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(SSIHeader, [{
    key: "render",
    value: function render() {
      return (0, _preact.h)(_HTMLContent.default, {
        html: this.props.html,
        className: (0, _classnames.default)(['ssi', 'ssi-header', 'custom-header'])
      });
    }
  }]);
  return SSIHeader;
}(_preact.Component);

var transformHeaderHtml = function transformHeaderHtml(html, props) {
  return html.replace('{username}', props.username).replace('{avatar}', props.avatar);
};

var _default = (0, _withSSIContent.withSSIContent)(SSIHeader, transformHeaderHtml);

exports.default = _default;